export default __webpack_public_path__ + "static/media/hamburger-about.92c8b2a5.jpg";